import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom';

import { Button } from './Button';
import './Navbar.css';

function Navbar() {

  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  return (
    <div>
      <nav className='navbar'>
        <div className='navbar-container container'>
          <Link  to='/' className='navbar-logo' onClick={closeMobileMenu}>
            <img src='./images/logo1.png' alt='Woof logo'></img>
          </Link>
          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
            <ul className={click ? 'nav-menu active' : 'nav-menu'}>
              <li className='nav-item'>
                <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                  Home
                </Link>
              </li>
              <li className='nav-btn'>
                {button ? (
                  <Link to='/signup' className='btn-link'>
                    <Button buttonStyle='btn--other'>SIGN UP</Button>
                  </Link>
                ) : (
                  <Link to='/signup' className='btn-link'>
                    <Button
                      buttonStyle='btn--other'
                      buttonSize='btn--mobile'
                      onClick={closeMobileMenu}>
                      SIGN UP
                    </Button>
                  </Link>
                )}
              </li>
              <li className='nav-btn'>
                {button ? (
                  <Link to='/login' className='btn-link'>
                    <Button buttonStyle='btn--other'>LOG IN</Button>
                  </Link>
                ) : (
                  <Link to='/login' className='btn-link'>
                    <Button
                      buttonStyle='btn--other'
                      buttonSize='btn--mobile'
                      onClick={closeMobileMenu}>
                      LOG IN
                    </Button>
                  </Link>
                )}
              </li>
            </ul>
        </div>
      </nav>
    </div>
  )
}

export default Navbar